import { GenerateFilter } from "../../lib/InputShare";

document.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll('[sui-block="sui/post-filter"]');

	blocks.forEach((block) => {
		if (block.hasAttribute("data-initialized")) return;
		block.setAttribute("data-initialized", "true");

		GenerateFilter(block);
	});
});
